import { connect } from 'react-redux';
import Drivers from '../../components/Dispatch/Drivers';
import { checkPermission } from '../../actions/settings_actions';
import { selectDriver, resetCurrentDriver } from '../../actions/dispatch_actions';

function mapStateToProps(state) {
  return {
    checkingPermission: state.settings.checkingPermission,
    checkPermissionSuccess: state.settings.checkPermissionSuccess,
    checkPermissionFailure: state.settings.checkPermissionFailure,
    selectedCompany: state.header.selectedCompany,
    currentDriver: state.dispatch.currentDriver,
  };
}

export default connect(mapStateToProps, { checkPermission, selectDriver, resetCurrentDriver })(Drivers);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/Drivers.jsx